
/* eslint-disable */
import React, { useState } from 'react';
import { Paper } from '@mui/material';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {useResponsiveStyles} from '../../utils/responsiveStyles';
import ContractsData from './components/ContractsData';
import Contract from './Contract';
import { ArrowBackIosRounded } from '@mui/icons-material';
import InvoicesData from './components/InvoicesData';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Contracts() {
  const [value, setValue] = useState(0);
  const styles = useResponsiveStyles();
  const [addCustomer, setAddCustomer] = useState(false);
  const [editCustomerData, setEditCustomerData] = useState(null);
  const isOpenPlanUpgrade = useSelector(state => state.upgradePlan.isOpen);
  const [addContractOpen, setAddContractOpen] = useState(false);



  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            minHeight: '32px', 
            '& .MuiTab-root': {
              fontSize: styles.fontSize12,
              minHeight: '32px', // Ensure individual tabs also decrease in height
              padding: '6px 12px', // Adjust padding
              minWidth: '60px', // Decrease tab width
              
            },
            '& .Mui-selected': {
              color: '#1976d2 !important', 
              // backgroundColor: '#e3f2fd', 
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#1976d2', 
            },
          }}
        >
          <Tab label="Contracts" {...a11yProps(0)} />
          <Tab label="Invoices" {...a11yProps(1)} />
          {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Paper elevation={1} sx={{ p: '4px' }}>
          {
            addContractOpen 
            ? <Contract setAddContractOpen={setAddContractOpen} />
            : <ContractsData setAddContractOpen={setAddContractOpen} />
          }
        </Paper>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <InvoicesData />
      </CustomTabPanel>
      {/* <CustomTabPanel value={value} index={2}>
        <Customers />
      </CustomTabPanel> */}
    </Box>
  );
}

// import * as React from 'react';
// import { Paper } from '@mui/material';
// import PropTypes from 'prop-types';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
// import Typography from '@mui/material/Typography';
// import Box from '@mui/material/Box';
// import CustomersData from './CustomersData';
// import Customers from '../Customers';
// import DetailsView from './DetailsView';

// function CustomTabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// CustomTabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.number.isRequired,
//   value: PropTypes.number.isRequired,
// };

// function a11yProps(index) {
//   return {
//     id: `simple-tab-${index}`,
//     'aria-controls': `simple-tabpanel-${index}`,
//   };
// }

// export default function CustomerMain() {
//   const [value, setValue] = React.useState(0);

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   return (
//     <Box sx={{ width: '100%' }}>
//       <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
//         <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
//           <Tab label="Customers" {...a11yProps(0)} />
//           <Tab label="Item Two" {...a11yProps(1)} />
//           <Tab label="Item Three" {...a11yProps(2)} />
//         </Tabs>
//       </Box>
//       <CustomTabPanel value={value} index={0}>
//         {/* <CustomersData /> */}
//         <Paper elevation={1} sx={{p:'4px'}}>
//         <DetailsView />
//         </Paper>
//       </CustomTabPanel>
//       <CustomTabPanel value={value} index={1}>
//         Item Two
//       </CustomTabPanel>
//       <CustomTabPanel value={value} index={2}>
//       <Customers  />
//       </CustomTabPanel>
//     </Box>
//   );
// }
